import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import Countdown from "react-countdown";
import ReactPlayer from "react-player";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../App";
import flag from "../../../../assets/images/Auditions/flag.png";
import vector from "../../../../assets/images/meetupEvent/Vector.png";
import ContdownTimerRender from "../../../../HelperComponent/ContdownTimerRender";

const PendingContentDetails = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const [event, setEvent] = useState([]);
  const [eventTime, setEventTime] = useState([]);
  const event_end_time = new Date(
    moment(event.event_date).format("LL") + " " + event.end_time
  ).getTime();

  const [meetingJoin, setMeetingJoin] = useState(false);
  const [slot, setSlot] = useState([]);

  useEffect(() => {
    const event_id = props.match.params.id;
    axios
      .get(`/api/star/learning_session/registered_user/${event_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setSlot(res.data.users);
        }
      });

    axios.get(`/api/star/learning_session/details/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data.event);
        setEventTime(res.data.event?.event_date);
        // alert(res.data.event?.date)
      }
    });
  }, [props.match.params.id, history]);

  const handleClick = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(`/api/star/learning_session/approve/${event.id}`)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            history.push("/superstar/learning-session/approved");
          }
        });
    });
  };

  // const joinRoute = (room_id) => {
  //   setMeetingJoin(true);
  //   axios.get("/sanctum/csrf-cookie").then((response) => {
  //     axios
  //       .get(`/api/sdk/get-token/admin`)
  //       .then((res) => {
  //         setMeetingJoin(false);
  //         const authName = localStorage.getItem("auth_name");

  //         history.push(
  //           `/video-meeting?token=${res.data.token}&meetingId=a3en-kih1-ls2r&webcamEnabled=true&micEnabled=true&name=${authName}`
  //         );
  //         // window.location.href = ;
  //       });
  //   });
  // };

  const timeCount = () => {
    let eventDate = event.event_date.split(" ");
    let startTime = event.start_time;
    let endTime = event.end_time;

    let start = moment(eventDate[0] + " " + startTime);
    let end = moment(eventDate[0] + " " + endTime);

    return end.valueOf() - start.valueOf();
  };

  const joinRoute = (room_id) => {
    const authName = localStorage.getItem("auth_name");
    // alert()
    setMeetingJoin(true);
    axios
      .get("/sanctum/csrf-cookie")
      .then((response) => {
        axios.get(`/api/sdk/get-token/admin`).then((res) => {
          // alert(res.data.token)
          setMeetingJoin(false);
          window.open(
            `/video-meeting?token=${
              res.data.token
            }&meetingId=${room_id}&webcamEnabled=true&micEnabled=true&name=${authName}&time=${
              timeCount() / 60000
            }&whiteboardEnabled=true&canDrawOnWhiteboard=true&canToggleWhiteboard=true&canChangeLayout=true&canPin=true&askJoin=false&participantCanToggleOtherMic=true&participantCanToggleOtherWebcam=true&canRemoveOtherParticipant=true`
          );
        });
      })
      .catch((err) => {
        alert("network problem");
      });
  };

  const setReject = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/learning_session/reject/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar/learning-session/rejected");
        }
      });
    });
  };

  // new countdown
  // const SessionStartTime = moment(eventTime).format('LL HH:mm:ss')
  const SessionStartTime =
    moment(eventTime).format("LL") + " " + event.start_time;

  const countDownDate = new Date(SessionStartTime).getTime();

  return (
    <>
      <div className="AS">
        <div className="container-fluid">
          {Number(event.status) > 0 ? (
            <div className="row mb-3">
              <div className="col-md-12 col-lg-6 mb-3 m-0 mb-3">
                <div className="card card-bg p-3 me-2">
                  {event.video ? (
                    <ReactPlayer
                      url={event.video}
                      controls={true}
                      volume={1}
                      width="100%"
                      maxHeight="450px"
                      className="img-fluid Banner-SME-b "
                      style={{ margin: "0 auto" }}
                    />
                  ) : (
                    <img
                      src={imageCdnUrl + event.banner}
                      alt=""
                      className="img-fluid Banner-SME-b "
                    />
                  )}

                      <Countdown
                          date={SessionStartTime}
                          renderer={ContdownTimerRender}
                        />
                </div>
              </div>

              <div className="col-md-12 col-lg-6 mb-3">
                <div className="row">
                  <div className="registration-head  card-bg mb-1">
                    <h5 className="text-warning fw-bold p-2">Registration </h5>
                  </div>

                  <div className="row registration-body  card-bg m-0 pt-3">
                    <div className="col-md-6 m-0 ">
                      <div className="d-flex registration-btn p-2">
                        <div className="mx-3 mt-2">
                          <span className="text-light">
                            <img src={flag} alt="" className="PriceTage" />
                          </span>
                        </div>
                        <div className=" mx-1">
                          <span className="text-light">
                            Registration Start:
                          </span>
                          <br></br>
                          <span className=" text-warning fw-bold">
                            {moment(event.registration_start_date).format("LL")}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 m-0 ">
                      <div className="d-flex registration-btn p-2">
                        <div className="mx-3 mt-2">
                          <span className="text-light">
                            <img src={flag} alt="" className="PriceTage" />
                          </span>
                        </div>
                        <div className=" mx-1">
                          <span className="text-light">Registration End:</span>
                          <br></br>
                          <span className=" text-warning fw-bold">
                            {moment(event.registration_end_date).format("LL")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row registration-body  card-bg m-0 pt-3">
                    <div className="col-md-6 m-0 ">
                      <div className="d-flex registration-btn p-2">
                        <div className="mx-3 mt-2">
                          <span className="text-light">
                            <img src={flag} alt="" className="PriceTage" />
                          </span>
                        </div>
                        <div className=" mx-1">
                          <span className="text-light">Fee:</span>
                          <br></br>
                          <span className=" text-warning fw-bold">
                            ${event.fee}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 m-0 ">
                      <div className="d-flex registration-btn p-2">
                        <div className="mx-3 mt-2">
                          <span className="text-light">
                            <img src={flag} alt="" className="PriceTage" />
                          </span>
                        </div>
                        <div className=" mx-1">
                          <span className="text-light">Participant</span>
                          <br></br>
                          <span className=" text-warning fw-bold">
                            {event.participant_number}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="row mb-3">
              <div className="col-md-6 m-0 mb-3">
                <div className="card card-bg p-3 me-2">
                  {event.video ? (
                    <ReactPlayer
                      url={event.video}
                      controls={true}
                      volume={1}
                      width="100%"
                      height="200px"
                      style={{ margin: "0 auto" }}
                      className="img-fluid Banner-SME-b "
                    />
                  ) : (
                    <img
                      src={imageCdnUrl + event.banner}
                      alt=""
                      className="img-fluid Banner-SME-b "
                    />
                  )}
                </div>
              </div>
              <div className="col-md-12 col-lg-6 mb-3">
                <div className="row">
                  <div className="registration-head  card-bg mb-1">
                    <h5 className="text-warning fw-bold p-2">Registration </h5>
                  </div>

                  <div className="row registration-body  card-bg m-0 pt-3">
                    <div className="col-md-6 m-0 ">
                      <div className="d-flex registration-btn p-2">
                        <div className="mx-3 mt-2">
                          <span className="text-light">
                            <img src={flag} alt="" className="PriceTage" />
                          </span>
                        </div>
                        <div className=" mx-1">
                          <span className="text-light">
                            Registration Start:
                          </span>
                          <br></br>
                          <span className=" text-warning fw-bold">
                            {moment(event.registration_start_date).format("LL")}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 m-0 ">
                      <div className="d-flex registration-btn p-2">
                        <div className="mx-3 mt-2">
                          <span className="text-light">
                            <img src={flag} alt="" className="PriceTage" />
                          </span>
                        </div>
                        <div className=" mx-1">
                          <span className="text-light">Registration End:</span>
                          <br></br>
                          <span className=" text-warning fw-bold">
                            {moment(event.registration_end_date).format("LL")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row registration-body  card-bg m-0 pt-3">
                    <div className="col-md-6 m-0 ">
                      <div className="d-flex registration-btn p-2">
                        <div className="mx-3 mt-2">
                          <span className="text-light">
                            <img src={flag} alt="" className="PriceTage" />
                          </span>
                        </div>
                        <div className=" mx-1">
                          <span className="text-light">Fee:</span>
                          <br></br>
                          <span className=" text-warning fw-bold">
                            ${event.fee}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 m-0 ">
                      <div className="d-flex registration-btn p-2">
                        <div className="mx-3 mt-2">
                          <span className="text-light">
                            <img src={flag} alt="" className="PriceTage" />
                          </span>
                        </div>
                        <div className=" mx-1">
                          <span className="text-light">Participant</span>
                          <br></br>
                          <span className=" text-warning fw-bold">
                            {event.participant_number}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row mt-1">
            <div className="col-md-12">
              <div className="card card-bg shadow">
                <div className="card-body">
                  <h5 className="text-light pb-3">{event.title}</h5>

                  <h5 className="text-warning">Instruction</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.instruction} />
                  </p>

                  <h5 className="text-warning">Description</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.description} />
                  </p>

                  <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                    <h5 className="text-warning pt-2 ">Event Date</h5>
                    <p className="text-light fw-bold pt-2">
                      {moment(event.event_date).format("LL")} |{" "}
                      {moment(event.start_time, "HH:mm:ss").format("hh:mm A")}-
                      {moment(event.end_time, "HH:mm:ss").format("hh:mm A")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card card-bg solt-card">
                <div className="card-body">
                  <h3 className="text-warning">
                    <img src={vector} alt="clock" className="mx-2"></img>
                    Registered User ({slot.length})
                  </h3>
                  <div className="row my-3">
                    {slot.map((user, index) => (
                      <div className="col-md-3 col-lg-2 mb-2 ">
                        <p className="sold-small-card fw-bold text-ellipsis">
                          <img
                            src={imageCdnUrl + user.user?.image}
                            className="img-fluid mx-2 p-1"
                            alt=""
                            style={{ height: "50px", width: "50px" }}
                          />
                          {user.user?.first_name} {user.user?.last_name}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {countDownDate <= new Date().getTime() &&
            Number(event.status) > 1 &&
            event_end_time > new Date().getTime() ? (
              <div className="mt-3 row">
                <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                  {meetingJoin ? (
                    <div className="col-md-4 mx-auto">
                      <button
                        className="btn btnJoinNow w-100 fw-bold px-5"
                        disabled
                      >
                        Join Now<i className="fas fa-spinner fa-pulse"></i>
                      </button>
                    </div>
                  ) : (
                    <div className="col-md-4 mx-auto">
                      <button
                        className="btn btnJoinNow w-100 fw-bold px-5"
                        onClick={() => joinRoute(event.room_id)}
                      >
                        Join Now
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : Number(event.status) < 1 ? (
              <div className="mt-3 row">
                <div className="col-md-9 row mx-auto">
                  <div className="col-md-4">
                    <div className="m-2">
                      <button
                        className="btn btnConfirm w-100 fw-bold"
                        onClick={handleClick}
                      >
                        Approve{" "}
                      </button>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="m-2">
                      <Link to={`/superstar/learning-session/edit/${event.id}`}>
                        <button className="btn btnEdit fw-bold w-100">
                          Edit
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="m-2">
                      <button
                        className="btn btnDecline w-100 text-dark fw-bold"
                        onClick={setReject}
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : Number(event.status) === 9 ? (
              <></>
            ) : (
              <div className="mt-3 row">
                {Number(event.status) < 2 &&
                event.created_by_id === event.star_id ? (
                  <div className="row">
                    <div className="col-md-3 mx-auto">
                      <div className="m-2">
                        <Link
                          to={`/superstar/learning-session/edit/${event.id}`}
                        >
                          <button className="btn btnEdit fw-bold px-3 mx-3">
                            Edit
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default PendingContentDetails;
